import { createAnnualMetricTable } from '../common/annualMetricTable';
export var OvertimeCostsTable = createAnnualMetricTable({
    metricKey: 'overtimeCosts',
    titleKey: 'reportRows.overtimeCosts',
    totalLabelKey: 'totalOvertimeCosts',
    unitKey: 'cost',
});
